























import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class Home extends Vue {

	ajouterPatient(): void {
		this.$router.push({
			name: 'accueil',
			query: Object.assign({}, this.$router.currentRoute.query)
		});
	}
}
